document.addEventListener('DOMContentLoaded', function () {
  const selectors = {
    cartList: '.drawer__content__items__list',
    cartProduct: '.drawer__content__items__list__product',
    subtotal: '.drawer__checkout__subtotal__amount',
    totalSaved: '.drawer__checkout__saved',
    totalSavedAmount: '.drawer__checkout__saved__amount',
    removeBtn: '.drawer__content__items__list__product__details__remove',
    decBtn: '.drawer__content__items__list__product__details__qty-group__dec',
    incBtn: '.drawer__content__items__list__product__details__qty-group__inc',
    qtyInput:
      '.drawer__content__items__list__product__details__qty-group__input',
    suggestedProductsMobile: '.drawer__content__suggested__products',
    suggestedContent: '.drawer__suggested__content',
    atcBtn: '.drawer__content__suggested__products__item__atc-btn',
    suggested: '.drawer__suggested',
    suggestedItem: '.drawer__content__suggested__products__item',
    suggestedMobile: '.drawer__content__suggested',
    drawerTrigger: '[data-drawer-trigger]',
    giftMessage: '.drawer__checkout__gift-message',
    giftMessageText: '.drawer__checkout__gift-message__text',
    giftMessageActive: '.drawer__checkout__gift-message--active',
    addMessage: '.drawer__checkout__message',
    addMessageHide: '.drawer__checkout__message--hide',
    addMessageBtn: '.drawer__checkout__message span',
    checkoutBtn: '.drawer__checkout__btn',
    removeGiftMessage: '.drawer__checkout__gift-message__remove',
    emptyState: '.drawer__empty',
    checkout: '.drawer__checkout',
  };

  const includedVariants = [
    '44959598805237',
    '44959677251829',
    '46585478349045',
    '46427389198581',
    '46450809995509',
    '46834467766517',
    '46834482610421',
    '46834395709685',
    '46487078240501',
    '46487081451765',
    '46881815363829',
    '47396039426293',
    '47396037165301',
    '47512937529589',
    '47648672547061',
    '47665537319157',
    '48067833135349',
    '47648673661173',
    '47648665633013',
    '47648665665781',
    '47648663404789',
    '47648663437557',
    '47648669106421',
    '47648667042037',
    '47648675266805',
    '47675304771829',
  ];

  const variantsDiscount30 = new Set([
    '46834467766517',
    '46834482610421',
    '46487078240501',
    '46487081451765',
    '46834395709685',
  ]);

  const wholesaleProductIds = new Set([
    '8493688586485',
    '8493687636213',
    '9341563044085',
    '9410456879349',
    '9553043783925',
    '9553043259637',
    '9712798040309',
    '9341563207925',
    '9341563273461',
    '9157986058485',
    '8046743814389',
    '8046742929653',
    '8046742667509',
    '8046743748853',
    '8046743060725',
    '8046742700277',
  ]);

  const MIN2_PROPERTY_KEYS = ['_25_min_2', '_30_min_2', '_35_min_2'];
  const MINIMUM_NOT_MET_KEY = '_minimum_not_met';

  function hasMin2Property(properties = {}) {
    return MIN2_PROPERTY_KEYS.some((key) => properties[key] === 'true');
  }

  function buildMinimumNotMetProperties(properties, quantity) {
    if (!hasMin2Property(properties)) return null;
    const next = { ...properties };
    if (quantity >= 2) {
      delete next[MINIMUM_NOT_MET_KEY];
    } else {
      next[MINIMUM_NOT_MET_KEY] = 'true';
    }
    return next;
  }

  function getSuggestedDiscountMultiplier(variantId) {
    return variantsDiscount30.has(String(variantId)) ? 0.7 : 0.8;
  }

  function formatSuggestedPrice(amount) {
    const value = parseFloat(amount);
    if (Number.isNaN(value)) return '$0.00';
    return '$' + value.toFixed(2);
  }

  function formatSuggestedDiscountHtml(comparePrice, multiplier) {
    const compare = parseFloat(comparePrice);
    const sale = compare * multiplier;
    return `<span style="margin-right: 4px;">${formatSuggestedPrice(sale)}</span><span style="text-decoration: line-through;">${formatSuggestedPrice(compare)}</span>`;
  }

  const COMPARE_PRICE_KEY = '_compare-price';

  function parseMoneyStringToCents(value) {
    const numeric = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (Number.isNaN(numeric)) return null;
    return Math.round(numeric * 100);
  }

  function getLineCompareCents(item) {
    const raw = item.properties?.[COMPARE_PRICE_KEY];
    if (!raw) return null;
    const unitCents = parseMoneyStringToCents(raw);
    if (unitCents == null) return null;
    return unitCents * item.quantity;
  }

  function getComparePriceHtml(item) {
    const lineCompareCents = getLineCompareCents(item);
    if (lineCompareCents == null) return '';
    if (lineCompareCents <= item.line_price) return '';
    return `<h3 class="drawer__content__items__list__product__details__price" style="text-decoration: line-through; margin-right: 8px;">${Shopify.formatMoney(lineCompareCents)}</h3>`;
  }

  if (document.querySelector(selectors.removeGiftMessage)) {
    document
      .querySelector(selectors.removeGiftMessage)
      .addEventListener('click', function (e) {
        e.preventDefault();
        removeGiftMessage();
      });
  }

  if (document.querySelector(selectors.checkoutBtn)) {
    document
      .querySelector(selectors.checkoutBtn)
      .addEventListener('click', function (e) {
        e.preventDefault();
        onCheckoutBtnClick();
      });
  }

  const onCheckoutBtnClick = async () => {
    const giftMessage = document.querySelector(selectors.giftMessageText);

    if (giftMessage?.value.trim().length) {
      await addGiftMessage(giftMessage.value.trim());
    }

    window.location.href = '/checkout';
  };

  const updateGiftMessage = (cartData) => {
    if (!cartData.note || !cartData.note.length) {
      return;
    }

    if (document.querySelector(selectors.giftMessageText)) {
      document.querySelector(selectors.giftMessageText).value = cartData.note;
      document
        .querySelector(selectors.addMessage)
        .classList.add(selectors.addMessageHide.slice(1));
      document
        .querySelector(selectors.giftMessage)
        .classList.add(selectors.giftMessageActive.slice(1));
    }
  };

  const addGiftMessage = async (message) => {
    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note: message }),
    };

    try {
      const res = await fetch('/cart/update.js', settings);

      if (res.status !== 200) {
        console.log('failed to update gift message');
      }
    } catch (err) {
      console.log(err);
    }
  };

  const removeGiftMessage = async () => {
    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note: '' }),
    };

    try {
      const res = await fetch('/cart/update.js', settings);

      if (res.status !== 200) {
        return;
      }

      const giftMessageText = document.querySelector(selectors.giftMessageText);
      const addMessage = document.querySelector(selectors.addMessage);
      const giftMessage = document.querySelector(selectors.giftMessage);

      if (giftMessageText) {
        giftMessageText.value = '';
      }
      if (addMessage) {
        addMessage.classList.remove(selectors.addMessageHide.slice(1));
      }
      if (giftMessage) {
        giftMessage.classList.remove(selectors.giftMessageActive.slice(1));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onAddMessageBtnClick = () => {
    const addMessage = document.querySelector(selectors.addMessage);
    const giftMessage = document.querySelector(selectors.giftMessage);

    if (addMessage) {
      addMessage.classList.add(selectors.addMessageHide.slice(1));
    }
    if (giftMessage) {
      giftMessage.classList.add(selectors.giftMessageActive.slice(1));
    }
  };

  const addMessageBtn = document.querySelector(selectors.addMessageBtn);
  if (addMessageBtn) {
    addMessageBtn.addEventListener('click', onAddMessageBtnClick);
  }

  window.addEventListener('resize', function () {
    const drawerTrigger = document.querySelector(selectors.drawerTrigger);

    if (
      drawerTrigger &&
      drawerTrigger.getAttribute('aria-expanded') === 'true'
    ) {
      updateSuggestedProducts();
    }
  });

  const getCartTotalSaved = (cart) =>
    cart.items.reduce((sum, item) => {
      const shopifySaved = Math.max(
        0,
        item.original_line_price - item.line_price,
      );
      const lineCompareCents = getLineCompareCents(item);
      const propertySaved =
        lineCompareCents != null
          ? Math.max(0, lineCompareCents - item.line_price)
          : 0;
      return sum + Math.max(shopifySaved, propertySaved);
    }, 0);

  const updateTotalSaved = (cart) => {
    const el = document.querySelector(selectors.totalSaved);
    const amountEl = document.querySelector(selectors.totalSavedAmount);
    if (!el || !amountEl) return;

    const savedCents = getCartTotalSaved(cart);
    if (savedCents <= 0) {
      el.setAttribute('hidden', '');
      amountEl.textContent = '';
      return;
    }

    amountEl.textContent = Shopify.formatMoney(savedCents);
    el.removeAttribute('hidden');
  };

  const updateSubtotal = async (cartData) => {
    const cart = cartData ? cartData : await getCartData();
    const subtotal = Shopify.formatMoney(cart.total_price);
    document.querySelector(selectors.subtotal).textContent = subtotal;
    updateTotalSaved(cart);
  };

  const updateDrawerEmptyState = (cart) => {
    if (!cart) return;

    const isEmpty = cart.item_count === 0;
    const emptyEl = document.querySelector(selectors.emptyState);
    const checkoutEl = document.querySelector(selectors.checkout);
    const cartList = document.querySelector(selectors.cartList);
    const itemsEl = document.querySelector('.drawer__content__items');

    if (emptyEl) {
      if (isEmpty) {
        emptyEl.removeAttribute('hidden');
      } else {
        emptyEl.setAttribute('hidden', '');
      }
    }

    if (checkoutEl) {
      checkoutEl.classList.toggle('drawer__checkout--hidden', isEmpty);
    }

    if (itemsEl) {
      itemsEl.classList.toggle('drawer__content__items--hidden', isEmpty);
    }

    if (isEmpty && cartList) {
      cartList.innerHTML = '';
    }
  };

  const addSuggestedToCart = async (variantId) => {
    const payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _drawer_upsell: 'true',
          },
        },
      ],
    };

    const sellingPlanId = '9835741429';

    const mvLpVariants = [
      '44959598805237',
      '44959677251829',
      '46585478349045',
      '46427389198581',
      '46450809995509',
    ];

    if (includedVariants.includes(variantId)) {
      payload.items[0]['selling_plan'] = sellingPlanId;
    }

    if (mvLpVariants.includes(variantId)) {
      payload.items[0]['properties'] = {
        ...payload.items[0]['properties'],
        _mv_lp: '',
      };
    }

    try {
      const settings = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };

      const res = await fetch('/cart/add.js', settings);
      const data = await res.json();

      await updateSuggestedProducts();

      await updateSubtotal();
      await populateCartData();
      await syncFunnelWithMultivitamin(data);
    } catch (err) {
      console.log(err);
    }
  };

  const getCartData = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      console.log(data);
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const syncCartMinimumNotMetProperties = async (cartData) => {
    const cart = cartData || (await getCartData());
    if (!cart?.items?.length) return cart;

    for (const item of cart.items) {
      const nextProps = buildMinimumNotMetProperties(
        item.properties,
        item.quantity,
      );
      if (!nextProps) continue;

      const shouldRemove =
        item.quantity >= 2 &&
        Object.prototype.hasOwnProperty.call(
          item.properties || {},
          MINIMUM_NOT_MET_KEY,
        );
      const shouldAdd =
        item.quantity < 2 &&
        !Object.prototype.hasOwnProperty.call(
          item.properties || {},
          MINIMUM_NOT_MET_KEY,
        );
      if (!shouldRemove && !shouldAdd) continue;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: nextProps,
        }),
      });
    }

    return getCartData();
  };

  const getProducts = async () => {
    try {
      const res = await fetch('/collections/suggested-products/products.json');
      const data = await res.json();

      return data.products;
    } catch (err) {
      console.log(err);
    }
  };

  const updateCartItemQty = async (e, type) => {
    const key = e.target.closest('.drawer__content__items__list__product')
      .dataset.key;
    const currentQty = parseInt(
      e.target.parentElement.querySelector(selectors.qtyInput).value,
      10,
    );
    let newQuantity;

    if (type === 'inc') {
      newQuantity = currentQty + 1;
    } else if (type == 'dec') {
      newQuantity = currentQty - 1;
    } else if (type == 'set') {
      newQuantity = parseInt(e.target.value, 10);
    } else {
      return;
    }

    const cart = await getCartData();
    const item = cart?.items?.find((line) => line.key === key);
    const changePayload = {
      id: key,
      quantity: newQuantity,
    };

    if (item && hasMin2Property(item.properties)) {
      const nextProps = buildMinimumNotMetProperties(
        item.properties,
        newQuantity,
      );
      if (nextProps) {
        changePayload.properties = nextProps;
      }
    }

    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(changePayload),
    };

    try {
      const res = await fetch('/cart/change.js', settings);
      const data = await res.json();
      await updateSubtotal(data);
      await populateCartData(data);
      await updateSuggestedProducts(data);
      await syncFunnelWithMultivitamin(data);
    } catch (err) {
      console.log(err);
    }
  };

  const removeCartItem = async (e) => {
    const key = e.target.closest('.drawer__content__items__list__product')
      .dataset.key;

    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: 0 }),
    };

    try {
      const res = await fetch('/cart/change.js', settings);
      const data = await res.json();
      await updateSubtotal(data);
      await populateCartData(data);
      await updateSuggestedProducts(data);
      await syncFunnelWithMultivitamin(data);
    } catch (err) {
      console.log(err);
    }
  };
  // black friday promo sync funnels with multivitamins
  const syncFunnelWithMultivitamin = async (cartData) => {
    const cartItems = cartData?.items;
    const funnelVariantId = 47238772916469;
    const multivitaminVariantId1 = 47245051461877;
    const multivitaminVariantId2 = 47245045793013;

    if (!cartData || !cartItems) {
      return;
    }
    const funnel = cartItems.filter((item) => {
      return (
        item.variant_id === funnelVariantId && item.properties._free_funnel
      );
    });

    const multivitamin = cartItems.filter(
      (item) =>
        item.id === multivitaminVariantId1 ||
        item.id === multivitaminVariantId2,
    );

    const funnelQuantity =
      funnel.length > 0
        ? funnel.reduce((acc, item) => acc + item.quantity, 0)
        : 0;
    const multivitaminQuantity =
      multivitamin.length > 0
        ? multivitamin.reduce((acc, item) => acc + item.quantity, 0)
        : 0;

    if (funnel.length == 0 && multivitamin.length > 0) {
      await addItemToCart(funnelVariantId, multivitaminQuantity, {
        _free_funnel: 'true',
      });

      const data = await getCartData();
      await updateSubtotal(data);
      await populateCartData(data);
      await updateSuggestedProducts(data);
    } else if (funnel.length > 0 && funnelQuantity != multivitaminQuantity) {
      await updateCartItemQtyByKey(funnel[0].key, multivitaminQuantity);
      const data = await getCartData();
      await updateSubtotal(data);
      await populateCartData(data);
      await updateSuggestedProducts(data);
    }
  };

  const addItemToCart = async (variantId, quantity, properties) => {
    const payload = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.log(err);
    }
  };

  const updateCartItemQtyByKey = async (key, quantity) => {
    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    settings['body'] = JSON.stringify({
      id: key,
      quantity: quantity,
    });
    try {
      const res = await fetch('/cart/change.js', settings);
      const data = await res.json();
    } catch (err) {
      console.log(err);
    }
  };

  // const renderMVTitle = (title) => {
  //   if (title == '1 Toddler / Unflavored')
  // }

  const cartItem = (item) => {
    const customCartImages = {
      44959677284597:
        'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/KMV_and_Iron_bundle_thumbnail_b240166b-df1b-4acf-a133-d327e6d6512e.png?v=1747312240',
      44959677251829:
        'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/30_Kids.png?v=1741821506',
      44959598805237:
        'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/31_Toddler.png?v=1741821478',
      44959598838005:
        'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/TMV_and_Iron_bundle_thumbnail_6d88077b-1856-4d95-a2b9-3909180ae2ce.png?v=1747312296',
    };

    const cartItemImage = customCartImages[item.variant_id]
      ? customCartImages[item.variant_id]
      : item.image;

    const isIron = [44959677284597, 44959598838005].includes(item.variant_id);
    return `<li class="drawer__content__items__list__product" data-variant-id="${
      item.variant_id
    }" data-key="${item.key}">
          <div class="drawer__content__items__list__product__img-container">
            <a href="${item.url}" style="text-decoration: none;">
              <img src="${cartItemImage}" alt="${
                item.product_title
              }" loading="eager">
            </a>
          </div>
          <div class="drawer__content__items__list__product__details"
          >
            <div class="drawer__content__items__list__product__details__group-one">            
              <a href="${
                item.url
              }" style="text-decoration: none; margin-right: 12px;">            
                <h2 class="drawer__content__items__list__product__details__title" style="margin-bottom:0;">
                  ${item.product_title.replace('- Bundle', '')} 
                </h2>

                ${
                  [8774962086133, 8774755549429].includes(item.product_id)
                    ? `<p>${item.variant_title
                        .split(' - ')[0]
                        .replace(
                          /(Toddlers \/|Toddler \/|Kids \/|Kid \/)/g,
                          'x',
                        )} - ${Shopify.formatMoney(
                        item.line_price /
                          parseInt(item.variant_title.charAt(0)),
                      )}/box</p>`
                    : item.variant_title || ''
                }

                ${
                  item.selling_plan_allocation
                    ? `<p class="drawer__content__items__list__product__details__plan" style="margin-top:0;">${
                        item.selling_plan_allocation.selling_plan.name ==
                        'Delivery every 1 month'
                          ? 'every 1 Month'
                          : item.selling_plan_allocation.selling_plan.name
                      }</p>`
                    : ''
                }
              </a>
               <button class="drawer__content__items__list__product__details__remove">
                <span class="visually-hidden">remove</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>
                  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>
                </svg>
              </button>
            </div>

            <div class="drawer__content__items__list__product__details__group-two">
              ${
                wholesaleProductIds.has(String(item.product_id))
                  ? `
                <div class="drawer__content__items__list__product__details__cases" style="font-size:14px;white-space:nowrap;padding:6px 0;">${
                  item.quantity
                } ${item.quantity === 1 ? 'unit' : 'units'}</div>
              `
                  : [7925066105077, 8774962086133, 8774755549429].includes(
                      item.product_id,
                    )
                  ? ''
                  : `
                <div class="drawer__content__items__list__product__details__qty-group">
                  <button type="button" class="drawer__content__items__list__product__details__qty-group__dec" ${
                    item.properties._free_funnel ? 'disabled' : ''
                  }>-</button>
                  <input type="number" value="${
                    item.quantity
                  }" class="drawer__content__items__list__product__details__qty-group__input">
                  <button type="button" class="drawer__content__items__list__product__details__qty-group__inc" ${
                    item.properties._free_funnel ? 'disabled' : ''
                  }>+</button>
                </div>  
              `
              }         
              <div style="display: flex;">
                ${
                  getComparePriceHtml(item) ||
                  (item.total_discount > 0
                    ? `<h3 class="drawer__content__items__list__product__details__price" style="text-decoration: line-through; margin-right: 8px;">${Shopify.formatMoney(
                        item.original_line_price,
                      )}</h3>`
                    : '')
                }
                <h3 class="drawer__content__items__list__product__details__price">
                  ${
                    item.line_price === 0
                      ? 'Free'
                      : Shopify.formatMoney(item.line_price)
                  }
                </h3>
              </div>
            </div>
          </div>
        </li>`;
  };

  const populateCartData = async (cartData) => {
    const cart = cartData ? cartData : await getCartData();
    const cartList = document.querySelector(selectors.cartList);
    const freeItems = cart.items.filter((item) => item.line_price === 0);
    const paidItems = cart.items.filter((item) => item.line_price > 0);
    const cartItemsSorted = [...paidItems, ...freeItems];
    let cartItems = '';

    for (let i = 0; i < cartItemsSorted.length; i++) {
      cartItems += cartItem(cartItemsSorted[i]);
    }

    cartList.innerHTML = cartItems;

    // attach remove buttons
    const removeBtns = document.querySelectorAll(selectors.removeBtn);

    removeBtns.forEach(function (btn) {
      btn.addEventListener('click', removeCartItem);
    });

    // attach dec/inc buttons
    const decBtns = document.querySelectorAll(selectors.decBtn);
    const incBtns = document.querySelectorAll(selectors.incBtn);
    const qtyInputs = document.querySelectorAll(selectors.qtyInput);

    decBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        updateCartItemQty(e, 'dec');
      });
    });

    incBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        updateCartItemQty(e, 'inc');
      });
    });

    // attach keyup input qty
    qtyInputs.forEach(function (input) {
      input.addEventListener(
        'keyup',
        debounce(function (e) {
          updateCartItemQty(e, 'set');
        }, 1000),
      );
    });

    updateDrawerEmptyState(cart);
  };

  const getSuggestedProducts = async (cart) => {
    const cartItems = cart.items;
    const handles = cartItems.reduce((prev, curr) => {
      prev.push(curr.handle);
      return prev;
    }, []);
    const products = await getProducts();

    if (!products) {
      return [];
    }

    if (!handles.length) {
      return products.filter(
        (item) =>
          item.variants[0].available && item.handle !== 'gift-card',
      );
    }

    return products.filter((item) => {
      if (!item.variants[0].available) {
        return false;
      } else if (handles.includes(item.handle)) {
        return false;
      } else if (item.handle === 'gift-card') {
        return false;
      }
      return true;
    });
  };

  const updateSuggestedProducts = async (cartData) => {
    const cart = cartData ? cartData : await getCartData();
    const suggestedProducts = await getSuggestedProducts(cart);

    // const suggested = document.querySelector(selectors.suggested)
    const suggestedMobile = document.querySelector(selectors.suggestedMobile);
    let formattedProducts = '';
    let formattedMobileProducts = '';

    if (!suggestedMobile) {
      return;
    }

    if (!suggestedProducts || !suggestedProducts.length) {
      // suggested.style.display = 'none'
      suggestedMobile.style.display = 'none';
      return;
    } else {
      suggestedMobile.style.display = 'block';
      // if (window.innerWidth < 768) {
      //   suggested.style.display = 'none'
      //   suggestedMobile.style.display = 'block'
      // } else {
      //   suggestedMobile.style.display = 'none'
      //   suggested.style.display = 'block'
      // }
    }

    function imageSource(product) {
      const variantId = product.variants[0].id;

      if (variantId === 44959598805237) {
        return 'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/31_Toddler.png?v=1741821478';
      }

      if (variantId === 44959677251829) {
        return 'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/30_Kids.png?v=1741821506';
      }

      if (variantId === 44959677284597) {
        return 'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/KMV_and_Iron_bundle_thumbnail_b240166b-df1b-4acf-a133-d327e6d6512e.png?v=1747312240';
      }

      if (variantId === 44959598838005) {
        return 'https://cdn.shopify.com/s/files/1/0576/8790/0323/files/TMV_and_Iron_bundle_thumbnail_6d88077b-1856-4d95-a2b9-3909180ae2ce.png?v=1747312296';
      }

      return product.images[0].src;
    }

    function getPrice(product) {
      const variant = product.variants[0];
      const variantId = String(variant.id);

      if (includedVariants.includes(variantId)) {
        return formatSuggestedDiscountHtml(
          variant.price,
          getSuggestedDiscountMultiplier(variantId),
        );
      }

      return '$' + variant.price;
    }

    suggestedProducts.slice(0, 4).forEach((product) => {
      formattedProducts += `
        <div class="drawer__suggested__content__item" data-variant-id="${
          product.variants[0].id
        }">
          <a href="/products/${product.handle}">
            <img src="${imageSource(product)}" alt="Product" loading="eager">
          </a>
          <a href="/products/${product.handle}">
            <h3>${product.title}${
              product.variants.length > 1
                ? ` - ${product.variants[0].title}`
                : ''
            }</h3>
          </a>
          <p class="drawer__suggested__content__item__price-text">${getPrice(product)}</p>
          <button type="button" class="drawer__suggested__content__item__atc-btn">Add to Bag</button>
        </div>
      `;
      formattedMobileProducts += `
      <div class="drawer__content__suggested__products__item" data-variant-id="${
        product.variants[0].id
      }">
        <a href="/products/${product.handle}">
          <img src="${imageSource(product)}" alt="Product" loading="eager">
        </a>
        <a href="/products/${product.handle}">
          <h3>${product.title}${
            product.variants.length > 1 ? ` - ${product.variants[0].title}` : ''
          }</h3>
        </a>
        <p class="drawer__content__suggested__products__item__price-text">${getPrice(product)}</p>
        <button type="button" class="drawer__content__suggested__products__item__atc-btn">Add</button>
      </div>
      `;
    });

    // document.querySelector(selectors.suggestedContent).innerHTML =
    //   formattedProducts
    document.querySelector(selectors.suggestedProductsMobile).innerHTML =
      formattedMobileProducts;
    const atcBtns = document.querySelectorAll(selectors.atcBtn);

    atcBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        addSuggestedToCart(
          this.closest(selectors.suggestedItem).dataset.variantId,
        );
      });
    });
  };

  const debounce = (func, wait, immediate) => {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  const drawer = function () {
    /**
     * Element.closest() polyfill
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
     */
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector;
      }

      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }

    // Trap Focus
    // https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
    //
    function trapFocus(element) {
      var focusableEls = element.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
      );
      var firstFocusableEl = focusableEls[0];
      var lastFocusableEl = focusableEls[focusableEls.length - 1];
      var KEYCODE_TAB = 9;

      element.addEventListener('keydown', function (e) {
        var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          /* shift + tab */ if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } /* tab */ else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      });
    }

    //
    // Settings
    //
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',
    };

    //
    // Methods
    //

    // Toggle accessibility
    var toggleAccessibility = function (event) {
      if (!event) return;
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };

    // Open Drawer
    var openDrawer = async function (trigger) {
      // Get cart data
      const cartData = await getCartData();

      await updateSuggestedProducts(cartData);
      updateGiftMessage(cartData);

      await updateSubtotal(cartData);

      await populateCartData(cartData);

      if (cartData.item_count > 0) {
        await syncFunnelWithMultivitamin(cartData);
      }

      // Find target (header trigger optional — e.g. listicle LP has no header)
      var targetId = trigger
        ? trigger.getAttribute('aria-controls')
        : 'cart-drawer';
      var target = document.getElementById(targetId);
      if (!target) return;

      // Make it active
      target.classList.add(settings.activeClass);

      // Make body overflow hidden so it's not scrollable
      document.documentElement.style.overflow = 'hidden';

      // Toggle accessibility
      toggleAccessibility(trigger);

      // Make it visible
      setTimeout(function () {
        target.classList.add(settings.visibleClass);
        trapFocus(target);
      }, settings.speedOpen);
    };

    // Close Drawer
    var closeDrawer = function (event) {
      // Find target
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector(
          '[aria-controls="' + closestParent.id + '"',
        );

      // Make it not visible
      closestParent.classList.remove(settings.visibleClass);

      // Remove body overflow hidden
      document.documentElement.style.overflow = '';

      // Toggle accessibility
      toggleAccessibility(childrenTrigger);

      // Make it not active
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
    };

    // Click Handler
    var clickHandler = function (event) {
      // Find elements
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);

      // Open drawer when the open button is clicked
      if (open) {
        openDrawer(open);
      }

      // Close drawer when the close button (or overlay area) is clicked
      if (close) {
        closeDrawer(close);
      }

      // Prevent default link behavior
      if (open || close) {
        event.preventDefault();
      }
    };

    // Keydown Handler, handle Escape button
    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // Find all possible drawers
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;

        // Find active drawers and close them when escape is clicked
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };

    //
    // Inits & Event Listeners
    //
    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
    Shopify.openCartDrawer = function () {
      const trigger = document.querySelector('[data-drawer-trigger]');
      openDrawer(trigger || null);
      return;
    };

    Shopify.addToCartAndOpenDrawer = async function (payload) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const data = await res.json();

        if (res.status !== 200) {
          console.error('Add to cart failed:', data);
          return { ok: false, data: data };
        }

        Shopify.openCartDrawer();
        return { ok: true, data: data };
      } catch (err) {
        console.error(err);
        return { ok: false, error: err };
      }
    };
  };

  drawer();

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.aq-accessory-grid__quick-add');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    btn.disabled = true;

    const payload = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
        },
      ],
    };

    const fourWeek = btn.getAttribute('data-4week-plan-id');
    const sellingPlan = btn.getAttribute('data-selling-plan-id');
    if (fourWeek) {
      payload.items[0].selling_plan = parseInt(fourWeek, 10);
    } else if (sellingPlan) {
      payload.items[0].selling_plan = parseInt(sellingPlan, 10);
    }

    const addToCart = Shopify.addToCartAndOpenDrawer;
    if (typeof addToCart !== 'function') {
      btn.disabled = false;
      return;
    }

    addToCart(payload).finally(function () {
      btn.disabled = false;
    });
  });
});